/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BUTTON_FORMAT_STRONG, BUTTON_THEME_PRIMARY, ICON_ADD_CIRCLE } from '@squiz/sds';
import React from 'react';
import { AddDamButton } from '../AddDamButton/AddDamButton';
import { DamIntegrationActionsProps } from './DamIntegrationActions.props';

/**
 * The actions for the DAM integrations screen.
 */
export const DamIntegrationActions = (props: DamIntegrationActionsProps): JSX.Element => {
  const { hasCreatePermission, tenantSetting } = props;

  return (
    <div className="dam-integration-actions">
      <AddDamButton
        disabled={!hasCreatePermission}
        format={BUTTON_FORMAT_STRONG}
        icon={ICON_ADD_CIRCLE}
        tenantSetting={tenantSetting}
        theme={BUTTON_THEME_PRIMARY}
      />
    </div>
  );
};
